// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Empty_wrapper__QbvCs","title":"Empty_title__w9u-Q","subtitle":"Empty_subtitle__kUwy7"};